module.exports = __webpack_public_path__ + "static/img/intermedio2.47f2f6d0.jpg";